import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { BRAND_ICON_SRC } from '../../../core/branding/brand-assets';
import { LanguageSwitcher } from '../language-switcher/language-switcher';
import { ThemeSwitcher } from '../theme-switcher/theme-switcher';
import { LandingAssistantWidget } from '../landing-assistant-widget/landing-assistant-widget';

@Component({
  selector: 'app-public-shell-layout',
  standalone: true,
  imports: [RouterLink, TranslatePipe, LanguageSwitcher, ThemeSwitcher, LandingAssistantWidget],
  templateUrl: './public-shell-layout.html',
  styleUrl: './public-shell-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicShellLayout {
  protected readonly brandIconSrc = BRAND_ICON_SRC;

  protected readonly footerLinks = [
    { path: '/terms-and-conditions', labelKey: 'PUBLIC_CONTENT.LINKS.TERMS' },
    { path: '/privacy-policy', labelKey: 'PUBLIC_CONTENT.LINKS.PRIVACY' },
    { path: '/refund-policy', labelKey: 'PUBLIC_CONTENT.LINKS.REFUND' },
    { path: '/delivery-policy', labelKey: 'PUBLIC_CONTENT.LINKS.DELIVERY' },
    { path: '/contact-us', labelKey: 'PUBLIC_CONTENT.LINKS.CONTACT' },
  ] as const;

  @Input() showFooter = true;
  /** When true, hides the top-bar Sign in action (e.g. on `/login` and password flows). */
  @Input() hideSignIn = false;
  /**
   * When true, shows the Workspace entry instead of Sign in (set by the host page from session state).
   * Kept as an input so this shared layout does not depend on app `core` services.
   */
  @Input() showWorkspaceEntry = false;
  /**
   * When true, mounts the anonymous landing assistant widget. Off by default so it
   * only appears on the marketing pages that opt in (home + public content), never on
   * `/login`, password flows, `/unauthorized` or the tenant-registration wizard.
   */
  @Input() showAssistant = false;
  /** Section links (Product / Why / Pricing / FAQ) — shown on marketing pages. */
  @Input() showNav = true;
  /** Landing sections paint edge to edge; other public pages sit in a centred 1180px frame. */
  @Input() fullBleed = false;
}
